export const hasSearchBoxDisplayed = (pathname: string | null) => {
  return pathname !== '/';
};
